<mat-button-toggle-group (change)="onChange($event.value)">
  <mat-button-toggle *ngFor="let item of optionsList" [value]=item.value>{{item.key | translate}}</mat-button-toggle>
</mat-button-toggle-group>
